import { ApiService } from "Services/ApiService";
import { SocialMediaLink, GetAllSocialMediaLinksArgs } from "../../Types/Admin/SocialMediaLinks";
import { ResultsDTO } from "Types/ResultsDTO";

export const ActiveSocialMediaApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getActiveSocialMediaLinks: builder.query<ResultsDTO<SocialMediaLink[]>, GetAllSocialMediaLinksArgs>({
      query: ({ plant }) => ({
        url: "/socialMediaLinks/active",
        method: "GET",
        params: { plant },
      }),
      providesTags: [{ type: "SocialMedia", id: "ACTIVE_LIST" }],
    }),
  }),
});

export const {
  useGetActiveSocialMediaLinksQuery,
  useLazyGetActiveSocialMediaLinksQuery,
} = ActiveSocialMediaApiSlice;
